<template>
    <svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 74"><defs></defs><path fill="#AEAEB3" d="M57.23,12.24a1.31,1.31,0,0,0-1-.3,1.39,1.39,0,0,0-1,.5,1.43,1.43,0,0,0,.2,2,29.72,29.72,0,0,1,11.2,23.5c0,16.5-13.1,29.9-29.2,29.9s-29.3-13.4-29.3-29.9a30,30,0,0,1,11.2-23.5,1.19,1.19,0,0,0,.5-.9,1.69,1.69,0,0,0-.3-1,1.43,1.43,0,0,0-2-.2,32.83,32.83,0,0,0-12.2,25.6c0,18.1,14.4,32.8,32.1,32.8s32-14.7,32-32.8A32.87,32.87,0,0,0,57.23,12.24Z"/><path fill="#AEAEB3" d="M37.43,36.64a1.54,1.54,0,0,0,1.5-1.5V7.54a1.5,1.5,0,1,0-3,0v27.7A1.45,1.45,0,0,0,37.43,36.64Z"/></svg>
</template>

<script>
export default {};
</script>
